import React, { useState } from 'react';
import { CURRENT_USER } from '../../services/currentUser';
import GamePlanSettings from './GamePlanSettings';
import './Settings.css';

/**
 * Settings — app-wide wording and options, stored in Supabase `app_settings` (admins edit, staff read).
 * First section: the customer game plan (2026-11-02).
 */
const SECTIONS = [
  { id: 'gamePlan', icon: '📋', title: 'Game plan', text: 'What customers get when their install day is confirmed — steps, timing, checklist.' },
];

const Settings = () => {
  const [open, setOpen] = useState(null);
  const isAdmin = CURRENT_USER.admin === true;

  if (open === 'gamePlan') return <GamePlanSettings isAdmin={isAdmin} onBack={() => setOpen(null)} />;

  return (
    <div className="set-page">
      <div className="set-head">
        <div>
          <h2>Settings</h2>
          <p className="set-muted">{isAdmin ? 'Changes here apply to every customer.' : 'You can view these; an admin makes changes.'}</p>
        </div>
      </div>
      {SECTIONS.map((s) => (
        <button key={s.id} type="button" className="set-tile" onClick={() => setOpen(s.id)}>
          <span className="set-tile-icon" aria-hidden="true">{s.icon}</span>
          <span>
            <b>{s.title}</b>
            <small>{s.text}</small>
          </span>
          <span aria-hidden="true">›</span>
        </button>
      ))}
    </div>
  );
};

export default Settings;
